module.exports = __webpack_public_path__ + "img/pic-20.c86c1edb.jpg";